import { useContext } from 'react';

import { HoneycombStoreContext } from '../context/honeycomb-store.context.js';
import {
  HoneycombOverlayState,
  HoneycombSelectionState,
} from '../types/state.js';

const useSetState = () => {
  const { setState } = useContext(HoneycombStoreContext);

  return setState;
};

export const useSetStateSelection = () => {
  const setState = useSetState();

  return (newSelectionState: Partial<HoneycombSelectionState>) => {
    setState((prev) => ({
      ...prev,
      selection: {
        ...prev.selection,
        ...newSelectionState,
      },
    }));
  };
};

export const useSetStateOverlay = () => {
  const setState = useSetState();

  return (newOverlayState: Partial<HoneycombOverlayState>) => {
    setState((prev) => ({
      ...prev,
      overlay: {
        ...prev.overlay,
        ...newOverlayState,
      },
    }));
  };
};
